import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

function onClick(event: MouseEvent) {
   const target = event.target as Element | null;
   const link = target?.closest<HTMLElement>('[data-track-menu-item]');
   if (!link) return;
   const title = link.dataset.trackMenuItem;
   if (!title) return;
   trackAnalyticsCustomEvent({
      eventCategory: 'Menu Tab',
      eventAction: `Menu Tab - "${title}" - Click`,
   });
}

function attach() {
   const container = document.querySelector('.headings-container');
   if (!container) return;
   container.addEventListener('click', onClick as EventListener);
}

if (document.readyState === 'loading') {
   document.addEventListener('DOMContentLoaded', attach);
} else {
   attach();
}
